module.exports = __webpack_public_path__ + "static/media/cooking-salon-ad4.02838732.jpg";